import { useNavigate, useParams } from 'react-router-dom';

import { ApiError } from '@/api/client';
import { Page } from '@/components/layout/Page';
import { EmptyState, ErrorState } from '@/components/ui/EmptyState';
import { Spinner } from '@/components/ui/Spinner';

import { useVacancy } from '../api';
import { VacancyForm } from '../components/VacancyForm';

export function VacancyEditorPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const vacancy = useVacancy(id);
  const close = () => {
    void navigate('/careers', { replace: true });
  };

  if (!id) return <VacancyForm vacancy={null} onClose={close} />;
  if (vacancy.isPending)
    return (
      <Page>
        <Spinner label="Loading vacancy" />
      </Page>
    );
  if (vacancy.isError) {
    return (
      <Page>
        {vacancy.error instanceof ApiError && vacancy.error.status === 404 ? (
          <EmptyState
            title="Vacancy unavailable"
            body="Go back to Vacancies to choose another record."
          />
        ) : (
          <ErrorState
            message="The vacancy could not be loaded."
            onRetry={() => {
              void vacancy.refetch();
            }}
          />
        )}
      </Page>
    );
  }
  return <VacancyForm key={id} vacancy={vacancy.data} onClose={close} />;
}
